import React from "react";
import SearchExamples from "../SearchExamples";
import SearchHistory from "../SearchHistory";
import SearchFavourites from "../SearchFavourites";
import { historyAndFavoritesClickFn, onInputSearchFn } from "../../@types";

interface ISuggestionsViewProps {
  onClose: () => void;
  onExampleSearch: (value: onInputSearchFn) => void;
  onHistoryAndFavoritesSearch: (value: historyAndFavoritesClickFn) => void;
}

const SuggestionsView = ({
  onClose,
  onHistoryAndFavoritesSearch,
  onExampleSearch
}: ISuggestionsViewProps) => {
  const onExampleSearchHandler = (
    q: string,
    { location }: { location: string }
  ) => {
    onExampleSearch({ query: q, location });
    onClose();
  };

  const onHistoryAndFavoritesSearchHandler = ({ item }: { item: string }) => {
    onHistoryAndFavoritesSearch({ query: item });
    onClose();
  };

  return (
    <div className="query-lists p-0">
      <div className="query-lists__sections-container m-0">
        <div className="query-lists__section">
          <SearchExamples onClick={onExampleSearchHandler} limit={3} />
        </div>
        <div className="query-lists__section">
          <SearchHistory onClick={onHistoryAndFavoritesSearchHandler} />
        </div>
        <div className="query-lists__section">
          <SearchFavourites onClick={onHistoryAndFavoritesSearchHandler} />
        </div>
      </div>
    </div>
  );
};

export default SuggestionsView;
